export default "__VITE_ASSET__BVjtb1Hx__"